<template>
    <v-card 
        ref="form"
        style="overflow:hidden"
    >
        <v-card-title style="position:relative">
            <span class="headline">{{ formTitle }}</span>
            <v-btn
                fab
                text
                small
                absolute
                right
                top
                class="mr-12"
                @click="registrationForm"
            >
                <v-icon>mdi-printer</v-icon>
            </v-btn>
            <v-btn
                color="red"
                absolute
                top
                right
                text
                fab
                small
                @click="close"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <v-row 
            justify="center"
            class="mx-0 mb-4"
        >
           
            <v-card
                flat 
                width="250"
                class="px-3 d-flex align-center flex-column"  
            >
                <v-card height="100" flat>
                    <v-row>
                        <v-col class="">
                                <v-text-field
                                    v-model="studentId"
                                    label="Student ID"                            
                                    outlined                            
                                    dense
                                    class="mt-4 record-summary"                            
                                ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>

                <v-card flat>
                    <v-row>
                        <v-col>
                            <v-card
                                v-if="studentRecord.picture"
                                outlined
                                class="mx-auto d-flex justify-center align-center"
                                max-width="200"
                            >
                                <v-img
                                    :src="studentRecord.picture"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                color="primary"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </v-card>
    
                            <v-card
                                v-else
                                outlined
                                class="mx-auto d-flex justify-center align-center"
                                width="200"
                                height="200"
                            >
                                <v-card-text
                                    class="my-auto" style="text-align:center"
                                >
                                    No Picture
                                </v-card-text>
                            </v-card>
                        </v-col>    
                    </v-row>    
                </v-card>
                

                <v-row v-if="editPicture">
                    <v-col class="pb-0">
                        <v-file-input
                            :value="pictureFile"
                            text
                            dense
                            outlined
                            @change="uploadPicture"
                            placeholder="Add/Change Picture"
                            prepend-icon="mdi-camera"
                            hide-details
                        >
                        </v-file-input>
                    </v-col>
                </v-row>

                <v-row v-if="pictureFile">
                    <v-col>
                        <v-card
                            class="mx-auto d-flex justify-center align-center"
                            width="200"
                        >
                            <v-progress-linear
                                v-model="progress"
                                color="blue-grey"
                                height="25"
                                
                                reactive
                            >
                                <strong>{{ progress }} %</strong>
                            </v-progress-linear>
                        </v-card>
                    </v-col>
                </v-row>
                
                <v-alert v-if="pictureUploadMessage" border="left" color="primary" dark>
                    {{ pictureUploadMessage}}
                </v-alert>  

                <v-row>
                    <v-col cols="12">
                        <v-card
                            class="mx-auto"
                            width="200"
                            flat
                        >
                            <div class="d-flex align-center">
                                <v-text-field
                                    v-model="studentRecord.serial_number"
                                    label="Serial Number"
                                    hide-details="auto"
                                    :disabled="lockSerialNumber"
                                    outlined
                                    :filled="lockSerialNumber"
                                    dense
                                    ref="serialNumber"
                                    @change="updateStudent"
                                ></v-text-field>
                                <v-btn
                                    icon
                                    small
                                    :disabled="!admin"
                                    @click="lock"
                                >
                                    <v-icon>{{ lockIcon }}</v-icon>
                                </v-btn>
                            </div>
                        </v-card>
                    </v-col>
                </v-row> 

                <v-row>
                    <v-col cols="12">
                        <v-card
                            class="mx-auto"
                            width="200"
                            flat
                        >
                            <v-btn @click="displayReportCards" block color="primary">Report Cards</v-btn>
                        </v-card>
                    </v-col>
                </v-row>     

                
            </v-card>
            
            <v-card
                width="500"
                flat                
                tile
                style="border-left: thin solid rgba(0, 0, 0, 0.12)"
                class=""                                    
            >
                <v-tabs
                    v-model="tab"
                    fixed-tabs
                >
                    
                    <v-tab
                        v-for="(item, i) in tabItems"
                        :key="i"
                        :disabled="item.disabled"                        
                    >
                        {{ item.section }}
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <data-general
                        v-bind:formClasses="formClasses"
                        v-bind:teachers="teachers"
                        v-bind:studentId = "studentId"
                        v-bind:houses = "houses"
                        v-on:update-students="updateStudents"
                        v-on:enable-tabs="enableTabs"
                        v-on:show-snackbar="showSnackbar"
                        ref="dataGeneral"
                    ></data-general>        
                    <data-personal
                        v-bind:record="dataPersonal"
                        v-bind:ethnicGroups="ethnicGroups"
                        v-bind:religiousGroups="religiousGroups"
                        v-on:show-snackbar="showSnackbar"
                    ></data-personal>
                    <data-medical
                        v-bind:record="dataMedical"
                        v-on:show-snackbar="showSnackbar"
                    ></data-medical>
                    <data-family
                        v-bind:records="dataFamily"
                        v-on:show-snackbar="showSnackbar"
                    ></data-family>
                </v-tabs-items>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        v-if="!studentRecord.student_id && !studentRecord.id && displayBtn"
                        @click="updateStudent(true)"
                    >
                        Add New Student
                    </v-btn>
                    <v-btn
                        color="primary"
                        v-else-if="displayBtn"
                        @click="updateStudent()"
                    >
                        Update Student
                    </v-btn>
                </v-card-actions>    
                
            </v-card>
              
        </v-row>        
        
        <v-overlay
            :value="overlay"
            opacity="0.8"
            z-index="10"
            absolute                    
        >
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>

         <PDFViewer
            :fileSrc="src"
            :initialDialog="reportViewer"
            :reportName="reportName"
            :downloadForm="true"
            @closeDialog="closeReport"
        />
        
        <v-snackbar
            v-model="snackbar.display"
            :color="snackbar.color"
        >
            {{ snackbar.text }}

            <template v-slot:action="{ attrs }">
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar.display = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>  
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DataGeneral from './StudentsEditDataGeneral.vue';
import DataPersonal from './StudentsEditDataPersonal.vue';
import DataMedical from './studentsEditDataMedical.vue';
import DataFamily from './studentsEditDataFamily.vue';
import UploadService from "../services/UploadFileService";
import PDFViewer from './PDFViewer.vue';

export default {
    components: {
        DataGeneral,
        DataPersonal,
        DataMedical,
        DataFamily,
        PDFViewer
    },

    props:{
        formTitle: {
            type: String,
            default: '',
        },
        
        formClasses: {
            type: Array,
            default: function () {
                return []
            }
        }
    },   

    created: function () {
        this.initialize();
    },

    computed: {
        ...mapGetters({
            studentRecord: 'students/getEditedStudent',
            user: 'auth/getUser',
        }),

        lockIcon () {
            if(this.lockSerialNumber) return "mdi-lock";
            return "mdi-lock-open";
        },
    },

    data: () => ({
        tab: null,
        tabItems: [
            { section: 'General Info', disabled: false},
            { section: 'Personal Info', disabled: false},  
            { section: 'Medical Info', disabled: false}, 
            { section:'Family Info', disabled: false}
        ],
        errorMessage: '',
        saved: false,
        error: false,
        overlay: false,        
        dataPersonal: {},
        dataMedical: {},
        dataFamily: {},
        religiousGroups: [],
        ethnicGroups: [],
        reportViewer: false,
        reportViewerOverlay: false,
        src: '',
        picture: false,
        pictureSrc: '',
        pictureFile: null,
        pictureUploadMessage: null,
        progress: 100,
        lazySrc: require('../assets/icons/student.svg'),
        editPicture: false,
        studentId: null,
        teachers: [],
        snackbar: {
            text: "",
            color: "primary",
            display: false
        },
        displayBtn: false,
        houses: [],
        lockSerialNumber: true,
        admin: false,
        reportName: null,
    }),
    
    watch: {
        tab: {
            handler (val) {
                this.displayBtn = true;
                if(val) this.displayBtn = false;
            }
        }
    },

    methods: {
        ...mapActions({
            getDataPersonal: 'students/getDataPersonal',
            getDataMedical: 'students/getDataMedical',
            getDataFamily: 'students/getDataFamily',
            getReligiousGroups: 'students/getReligiousGroups',
            getEthnicGroups: 'students/getEthnicGroups',
            postStudent: 'students/postStudent',
            getTeachers: 'employees/getTeachers',
            getHouses: 'students/getHouses',
        }),

        async initialize () {
            console.log("initializing");
            const { permissions } = JSON.parse(this.user); 
            permissions.forEach(permission => {
                if(permission.user_permission_id == 9){
                    this.admin = true;
                }
            })
            this.overlay = true;
            if(!this.studentRecord.student_id){
                this.tabItems.forEach(item => {
                    if(item.section != 'General Info') item.disabled = true;
                })
            }
            else{
                this.studentId = this.studentRecord.student_id;
            }
            this.getData();
            
        },

        enableTabs () {
            this.tabItems.forEach(item => {
                item.disabled = false;
            })
            this.overlay = false;
        },

        showSnackbar ({ color, text}) {
            this.overlay = false;
            this.snackbar.color = color;
            this.snackbar.text = text;
            this.snackbar.display = true;
        },

        async getData () {
            const promiseDataPersonal = this.getDataPersonal();
            const promiseDataMedical = this.getDataMedical();
            const promiseDataFamily = this.getDataFamily();
            const promiseReligiousGroups = this.getReligiousGroups();
            const promiseEthnicGroups = this.getEthnicGroups();
            const promiseTeachers = this.getTeachers();
            const promiseHouses = this.getHouses();

            try {
                const [
                    { data: dataPersonal },
                    { data: dataMedical },
                    { data: dataFamily }, 
                    { data: religiousGroups }, 
                    { data: ethnicGroups },
                    { data: dataTeachers },
                    { data: dataHouses }
                ] = await Promise.all([
                    promiseDataPersonal,
                    promiseDataMedical,
                    promiseDataFamily,
                    promiseReligiousGroups,
                    promiseEthnicGroups,
                    promiseTeachers,
                    promiseHouses,
                ])

                this.dataPersonal = dataPersonal;
                // this.loadPicture(dataPersonal);
                this.dataMedical = dataMedical;
                this.dataFamily = Array.isArray(dataFamily) ? {} : dataFamily;

                this.religiousGroups = religiousGroups.map(group => {
                    return {
                        id: group.id,
                        title: group.grouping
                    }
                })

                this.ethnicGroups = ethnicGroups.map(group => {
                    return {
                        id: group.id,
                        title: group.grouping
                    }
                })

                this.parseTeachers(dataTeachers);
                this.houses = dataHouses;
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }    
            
            this.overlay = false;
        },

        parseTeachers (data) {
            data.forEach(record => {
                record.text = record.first_name + " " + record.last_name;
            })
            this.teachers = data;
        },

        updateStudent (newStudent = false) {
            this.overlay = true;
            // console.log(`Validate ${this.$refs.dataGeneral.validate()}`)
            if(!this.$refs.dataGeneral.validate()){
                this.overlay = false;
            } 
            else{
                this.$refs.dataGeneral.update(newStudent);
            }
        },

       

        close () {
            this.$emit("close");
            this.tab = null;
            this.error = false;
            this.saved = false;
            this.date = null;
            // Object.keys(this.studentRecord).forEach(f => {
            //     if(f === 'first_name' || f === 'last_name' || f === 'form_class_id'){
            //         this.$refs[f].reset()
            //     }                
            // })
        },
        
        updateStudents (student_id) {
            this.studentId = student_id;
            this.overlay = false;
            this.$emit('update-students');
        },

        registrationForm () {
            this.reportViewer = true;
            this.src = process.env.VUE_APP_API_URI + "/api/registration-form?id="
            + this.studentRecord.student_id;
        },

        closeReport () {
            this.reportViewer = false;
            this.src = null;
        },        

        async uploadPicture (file) {
            this.progress = 0;
            this.pictureFile = file;
            console.log(this.pictureFile);
            if(!this.pictureFile){
                // this.pictureUploadMessage = "Please select a file!";
                return;
            }
            this.pictureUploadMessage = null;

            try {
                const { data } = await UploadService.upload(
                this.pictureFile, 
                this.studentRecord.student_id,
                'picture',
                (event) => {
                    this.progress = Math.round((100 * event.loaded) / event.total);
                    } 
                )
                this.studentRecord.picture = data.picture;
                this.$emit('update-students');
                // console.log(data);
                
            } catch (error) {
               if(error.response) console.log(error.response);
               else console.log(error); 
            }
            this.pictureFile = null;
            
        },

        async lock () {
            this.lockSerialNumber = !this.lockSerialNumber
            this.$refs.serialNumber.focus();
            // if(this.lockSerialNumber) this.updateStudent();
            // else {
            //     this.$refs.serialNumber.focus();
            //     console.log(this.$refs)
            // }
        },

        displayReportCards () {
            this.reportViewer = true;
            this.src = process.env.VUE_APP_API_URI + 
            `/api/report-card?student_id=${this.studentRecord.student_id}`;
            this.reportName = `${this.studentRecord.first_name} ${this.studentRecord.last_name}`;
        }

        
    }
}
</script>

<style scoped>
    ::v-deep .v-tab{
        max-width: 120px;
    }

    ::v-deep .v-slide-group__prev{
        display: none;
    }

    ::v-deep .v-btn--fab.v-size--small.v-btn--absolute.v-btn--top{
        top: 4px;
        right: 4px;
    }

    ::v-deep .record-summary input{
        font-weight: bold;
    }

    ::v-deep .theme--light.v-file-input .v-file-input__text--placeholder{
        font-size: 0.8rem;
    }
</style>